import { Component, input, ChangeDetectionStrategy } from "@angular/core";
import { TypeManagerDecorator } from "../../main/type.map.service";

@TypeManagerDecorator("s25-ng-eval25-score")
@Component({
    selector: "s25-ng-eval25-score",
    template: `
        <img
            src="./resources/typescript/assets/images/eval25Logo.png"
            alt="Eval25 Logo"
            class="eval25__logo light-mode"
        />
        <img
            src="./resources/typescript/assets/images/eval25Logo-darkmode.png"
            alt="Eval25 Logo"
            class="eval25__logo night-mode"
        />
        <div>Location Satisfaction</div>
        <div class="eval25__stars" [style.--rating]="score()"></div>
    `,
    styleUrls: ["./s25.eval25.score.component.scss"],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        "[class.eval25]": "true",
        role: "img",
        "[attr.aria-label]": "'Eval25 Location Satisfaction Score ' + score() + ' out of 5'",
    },
})
export class S25Eval25ScoreComponent {
    public readonly score = input.required<number>();
}
